var BadgeHierarchies = ['primary', 'secondary', 'tertiary', 'basic'];
var BadgeIntents = ['price', 'error', 'intense', 'positive', 'urgency', 'notice', 'neutral-1', 'neutral-2', 'interactive', 'family', 'rating-hotel', 'rating-nha'];

export { BadgeHierarchies, BadgeIntents };
//# sourceMappingURL=types.js.map
